import { render } from "./training-plans-links.vue?vue&type=template&id=61bed9e0&scoped=true"
import script from "./training-plans-links.vue?vue&type=script&lang=js"
export * from "./training-plans-links.vue?vue&type=script&lang=js"

import "./training-plans-links.vue?vue&type=style&index=0&id=61bed9e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bed9e0"]])

export default __exports__